import { NonNegative } from './non-negative';

interface Subscriptions {
  [key: string]: NonNegative | undefined;
}

const get = (subscriptions: Subscriptions, channel: string) =>
  subscriptions[channel] ?? NonNegative.zero();
const set = (
  subscriptions: Subscriptions,
  channel: string,
  value: NonNegative,
): Subscriptions => {
  subscriptions[channel] = value;

  return subscriptions;
};

export const Subscriptions = {
  empty: (): Subscriptions => ({}),
  add: (subscriptions: Subscriptions, channel: string): Subscriptions =>
    set(
      subscriptions,
      channel,
      NonNegative.increment(get(subscriptions, channel)),
    ),
  remove: (subscriptions: Subscriptions, channel: string): Subscriptions =>
    set(
      subscriptions,
      channel,
      NonNegative.decrement(get(subscriptions, channel)),
    ),
  has_none: (subscriptions: Subscriptions, channel: string): boolean =>
    NonNegative.is_zero(get(subscriptions, channel)),
};
